<template>
  <div>
    <template>
      <div class="form-row mb-3">
        <b-col cols="12" sm="12">
          <input
            type="text"
            v-model="sender"
            maxlength="11"
            class="form-control"
            placeholder="enter sender"
          />
        </b-col>
      </div>
      <div class="form-row mb-3">
        <b-col cols="12" sm="12">
          <textarea
            v-model="content"
            class="form-control"
            id="pn"
            placeholder="type a sample message."
          ></textarea>
          <small
            ><span class="text-danger"
              >Let your message be descriptive to speed up approval process.
              Review and approval takes an 1hr to 48hrs, so kindly submit your
              sender name 2days to 3days ahead of the day you want to send your
              message. You'll be notified once it's approved.</span
            ></small
          >
        </b-col>
        <div class="pull-right block">
          <span class="small muted" v-if="hasContent">{{
            pageCharacters
          }}</span>
        </div>
      </div>
    </template>
    <b-button
      type="button"
      variant="primary"
      class="mt-1"
      block
      @click="handleRequest"
    >
      <span v-if="!loading">{{ senderActionText }}</span>
      <div class="sk-circle" v-if="loading">
        <div class="sk-circle1 sk-child"></div>
        <div class="sk-circle2 sk-child"></div>
        <div class="sk-circle3 sk-child"></div>
        <div class="sk-circle4 sk-child"></div>
        <div class="sk-circle5 sk-child"></div>
        <div class="sk-circle6 sk-child"></div>
        <div class="sk-circle7 sk-child"></div>
        <div class="sk-circle8 sk-child"></div>
        <div class="sk-circle9 sk-child"></div>
        <div class="sk-circle10 sk-child"></div>
        <div class="sk-circle11 sk-child"></div>
        <div class="sk-circle12 sk-child"></div>
      </div>
      <i v-if="flashSendError" class="fa fa-times"></i>
    </b-button>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import {} from '@/services/notification.service';
import { EventBus } from '@/events/bus.event';

export default {
  name: 'SenderRegistration',
  data() {
    return {
      sender: '',
      senderActionText: 'Submit Request',
      flashSendError: false,
      pageCharacters: '',
      content: '',
      hasContent: false,
    };
  },
  notifications: {
    showSuccess: {
      title: 'Success',
      message: 'Your new sender name request has been successfully submitted!',
      type: 'success',
    },
    showFailed: {
      title: 'Failed',
      message: 'All refields are required',
      type: 'error',
    },
  },
  computed: {
    ...mapState('user', ['user', 'loading']),
  },
  methods: {
    ...mapActions('user', ['requestSenderRegistration']),
    async handleRequest() {
      if (this.loading) return;

      if (this.sender == '' || this.content == '') {
        this.showFailed();
        return;
      }

      let requestData = {
        sender: this.sender,
        message: this.content,
      };

      this.senderActionText = '';
      let status = await this.requestSenderRegistration({ data: requestData });
      this.senderActionText = 'Submit Request';

      if (!status) {
        this.flashSendError = true;
        this.showFailed({
          message:
            'Issue occurred while submitting your sender name. Try again',
        });

        let interval = setInterval(() => {
          this.flashSendError = false;
          clearInterval(interval);
        }, 1000);
      } else {
        this.showSuccess();
        this.$emit('isVisible', false);
      }
    },
  },
  watch: {
    content(newValue, oldValue) {
      const MAX_SINGLE = 160;
      const MAX_MULTIPLE = 151;
      let pageLen =
        this.content.length <= MAX_SINGLE ? MAX_SINGLE : MAX_MULTIPLE;
      let pages = Math.ceil(this.content.length / pageLen);

      this.pageCharacters = `Pages: ${pages} (Maximum Charaters: ${pageLen *
        pages}), Characters left: ${pageLen * pages -
        this.content.length}, Typed Characters: ${this.content.length}`;

      this.hasContent = this.content.length > 0;
    },
  },
};
</script>

<style scoped>
.sk-circle {
  margin: 0 auto 1px auto;
  width: 20px;
  height: 20px;
  position: relative;
  color: white !important;
}
</style>
